import { ChevronDown, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import type { ToolCallState } from '../../types';

export function ToolCallIndicator({ tc }: { tc: ToolCallState }) {
  const [open, setOpen] = useState(false);
  const hasInputs = !!tc.inputs && Object.keys(tc.inputs).length > 0;

  return (
    <div className={`tool-call${tc.status === 'done' ? ' tool-call-done' : tc.status === 'error' ? ' tool-call-error' : ''}`}>
      <div className="tool-call-header">
        {tc.status === 'calling' && <span className="tool-call-spinner" />}
        {tc.status === 'done' && <span className="tool-call-check">✓</span>}
        {tc.status === 'error' && <span className="tool-call-error-icon">✗</span>}
        <span className="tool-call-name">{tc.name}</span>
        {hasInputs && (
          <button className="tool-call-inputs-toggle" onClick={() => setOpen((current) => !current)}>
            {open ? <ChevronDown size={12} strokeWidth={2} /> : <ChevronRight size={12} strokeWidth={2} />}
            <span>inputs</span>
          </button>
        )}
      </div>
      {hasInputs && open && (
        <div className="tool-call-inputs">
          {Object.entries(tc.inputs!).map(([k, v]) => (
            <div key={k} className="tool-call-input-row">
              <span className="tool-call-input-key">{k}:</span>
              <span className="tool-call-input-val">{JSON.stringify(v)}</span>
            </div>
          ))}
        </div>
      )}
      {tc.status === 'error' && tc.error && (
        <div className="tool-call-details">{tc.error}</div>
      )}
    </div>
  );
}
